import { browserCookies } from '@gousto-internal/storage-consent-web-package'
import { useDecision } from '@optimizely/react-sdk'
import useSWR from 'swr'

import { menuExperimentsFetcher } from '@library/api-menu-experience'

import { GOUSTO_ANYTIME_FLAG } from './useDeliverySettings'

export const GOUSTO_ANYTIME_MENU_EXPERIMENT_KEY = 'gousto-anytime'
export const VARIANT = 'variant'

export const useGoustoAnytimeMenuVariant = (): boolean => {
  const [decision] = useDecision(GOUSTO_ANYTIME_FLAG)

  // Skip the fetch without an exp user id: the endpoint 400s without the header.
  const [, cookieValue] = browserCookies.getJSON<{ exp_user_id: string }>('v1_exp_user_id')
  const hasExperimentationUserId = Boolean(cookieValue?.exp_user_id)

  const { data } = useSWR(
    decision.enabled && hasExperimentationUserId ? 'gousto-anytime-menu-experiments' : null,
    menuExperimentsFetcher,
  )

  return data?.experiments[GOUSTO_ANYTIME_MENU_EXPERIMENT_KEY] === VARIANT
}
